import { render, staticRenderFns } from "./RecuperarPass.vue?vue&type=template&id=2ff62963&scoped=true"
import script from "./RecuperarPass.vue?vue&type=script&lang=js"
export * from "./RecuperarPass.vue?vue&type=script&lang=js"
import style0 from "./RecuperarPass.vue?vue&type=style&index=0&id=2ff62963&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff62963",
  null
  
)

export default component.exports